// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { getImageProviderListFailed, getImageProviderListRequested, getImageProviderListSucceeded } from './select-image-provider.actions';
import { ImageProviderListResponse } from '@par/app/core/model/dictionaries.response';

export const STATE_NAME_SELECT_IMAGE_PROVIDER = 'select-image-provider';

export interface State {
  response?: ImageProviderListResponse;
  responseError: boolean;
  responseLoading: boolean;
}

const initialState: State = {
  response: undefined,
  responseError: false,
  responseLoading: false,
};

const reducer = createReducer(
  initialState,
  on(getImageProviderListRequested, (state) => ({...state, response: undefined, responseLoading: true, responseError: false})),
  on(getImageProviderListSucceeded, (state, {response}) => ({...state, responseLoading: false, response, responseError: false})),
  on(getImageProviderListFailed, (state) => ({...state, responseLoading: false, responseError: true})),
);

export function selectImageProviderReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

